import React from 'react';
import classNames from 'classnames';
import { Tooltip } from 'antd';

import {
  PLAN_EXPIRY_STATUS_LABEL,
  getPlanExpiryStatus
} from './plan-expiry-shared';
import { ReactComponent as ExpiryIcon } from '../../scenes/Dashboard/assets/expiry-icon.svg';

import './PlanExpiryBadge.scss';

const STATUS_CARD_LABEL = {
  'not-expired': 'Active',
  'expiring-soon': 'Expires soon',
  expired: 'Expired'
};

function PlanExpiryBadge({ expiry, className, compact, header, tooltipTitle, tooltipPlacement, onExpiredClick }) {
  if (!expiry) return null;

  const status = getPlanExpiryStatus(expiry);
  if (!status) return null;

  const descriptive = PLAN_EXPIRY_STATUS_LABEL[status];
  const badgeText = STATUS_CARD_LABEL[status];
  const baseTitle = tooltipTitle ?? `Expiry · ${descriptive} (${expiry})`;
  const renewableExpired = status === 'expired' && typeof onExpiredClick === 'function';
  const title = renewableExpired ? `${baseTitle}. Click to renew.` : baseTitle;

  const badgeClassName = classNames(
    'plan-expiry-badge',
    `plan-expiry-badge--${status}`,
    compact && 'plan-expiry-badge--compact',
    header && 'plan-expiry-badge--header',
    renewableExpired && 'plan-expiry-badge--renewable',
    className,
  );

  const body = (
    <>
      <ExpiryIcon aria-hidden="true" className="plan-expiry-badge__icon" />
      <div className="plan-expiry-badge__main">
        <span className="plan-expiry-badge__date">{expiry}</span>
        <span className="plan-expiry-badge__status">{badgeText}</span>
      </div>
    </>
  );

  return (
    <Tooltip title={title} placement={tooltipPlacement || 'top'}>
      {renewableExpired ? (
        <button
          type="button"
          className={badgeClassName}
          aria-label={`${descriptive}. Click to renew.`}
          onClick={() => onExpiredClick()}
          onKeyDown={(e) => {
            if (e.key !== 'Enter' && e.key !== ' ') return;
            e.preventDefault();
            onExpiredClick();
          }}
        >
          {body}
        </button>
      ) : (
        <div className={badgeClassName} aria-label={descriptive}>
          {body}
        </div>
      )}
    </Tooltip>
  );
}

export default PlanExpiryBadge;
